import React, { useContext, useState } from 'react';
import {
  Button,
  FormatText,
  FormDatePicker,
  FormInput,
  FormItem,
  FormSubmitButton,
  usePromise,
  Widget,
  CrudContext,
  FormSelect,
  InlineEditTable,
  FormNumber,
  InlineEditColumnProps,
  MasterDetailForm,
  FormTextArea,
  OptionProps,
  ColumnType,
  Table,
  ButtonDelete,
} from '@digital/ui';
import * as Yup from 'yup';
import { Icon, Collapse, Tooltip } from 'antd';
import {
  getAllSeguroGarantias,
  SeguroGarantia,
  updateSeguroGarantia,
  createSeguroGarantia,
  deleteSeguroGarantia,
  download,
} from '../../../api/contrato/seguroGarantiaContrato';
import { getTipoDocumentoSeguroGarantiaOptions } from '@app/api/tipoDocumentoSeguroGarantia';
import { UploadFile } from '@app/components';
import { hasPermission } from '@app/helpers/permissions';
import PerfectScrollbar from 'react-perfect-scrollbar';

const AbaSegurosGarantias = () => {
  const handleDownloadFile = (values: any) =>
    download(values.localArquivo + '\\' + values.nomeArquivo, values.nomeArquivo);

  const columns = () => {
    const [tiposDocumento] = usePromise(getTipoDocumentoSeguroGarantiaOptions, [], [] as OptionProps[]);
    return [
      {
        title: 'Nome',
        dataIndex: 'nome',
        renderEdit: () => <FormInput name="nome" required />,
        width: '30%',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: '20%',
      },
      {
        title: 'Tipo',
        dataIndex: 'tipoDocumentoSeguroGarantiaId',
        options: tiposDocumento,
        renderEdit: () => <FormSelect name="tipoDocumentoSeguroGarantiaId" options={tiposDocumento} required />,
        width: '10%',
      },
      {
        title: 'Número',
        dataIndex: 'numero',
        renderEdit: () => <FormNumber name="numero" required />,
        width: '10%',
      },
      {
        title: 'Vigência - Início',
        dataIndex: 'vigenciaInicio',
        type: ColumnType.Date,
        renderEdit: () => <FormDatePicker name="vigenciaInicio" format="DD/MM/YYYY" required />,
        width: '5%',
      },
      {
        title: 'Vigência - Fim',
        dataIndex: 'vigenciaFim',
        type: ColumnType.Date,
        renderEdit: () => <FormDatePicker name="vigenciaFim" format="DD/MM/YYYY" required />,
        width: '5%',
      },
      {
        title: 'Descrição',
        dataIndex: 'descricao',
        renderEdit: () => <FormInput name="descricao" />,
        width: '30%',
      },
      {
        title: 'Upload',
        renderEdit: (item: any) => <UploadFile hasFile={false} label={' '} />,
        width: '5%',
      },
      {
        title: 'Opções',
        width: '5%',
        render: (item: any) => (
          <>
            {item.nomeArquivo && (
              <Tooltip title="Baixar Arquivo">
                <Button
                  onClick={() => {
                    handleDownloadFile(item);
                  }}
                  icon="ui-download"
                />
              </Tooltip>
            )}
            {hasPermission(['CONTRATO_SEGURO_GARANTIA_DELETAR']) && (
              <Tooltip title="Deletar Item">
                <ButtonDelete
                  type="link"
                  confirm="Deseja realmente excluir este registro?"
                  okText="Confirmar"
                  onClick={() => handleDelete(item.id)}
                  icon="science-minus"
                  className="btn-delete-without-text"
                />
              </Tooltip>
            )}
          </>
        ),
      },
    ] as InlineEditColumnProps<SeguroGarantia>[];
  };

  const [updateList, setUpdateList] = useState();

  const { selectedItem } = useContext(CrudContext);

  const [segurosGarantias] = usePromise<SeguroGarantia[]>(
    () => (selectedItem ? getAllSeguroGarantias(selectedItem.id) : Promise.resolve(undefined)),
    [selectedItem, updateList],
    [],
  );

  const [file, setFile] = useState(false);
  const [dataValue, setDataValue] = useState({});
  const { Panel } = Collapse;

  const submitCreateSeguroGarantia = (values: any) =>
    createSeguroGarantia(values.formData, values, selectedItem.id).then(resp => {
      if (resp.valid) {
        setUpdateList(false);
        setUpdateList(true);
        setDataValue([{ data: 'data' }]);
        setDataValue([]);
        setFile(true);
        setFile(false);
      }
    });

  const handleUpdate = (values: any) =>
    updateSeguroGarantia(values.formData, values, selectedItem.id).then(resp => {
      if (resp.valid) {
        setUpdateList(false);
        setUpdateList(true);
      }
    });
  const handleDelete = (values: any) =>
    deleteSeguroGarantia(values).then(resp => {
      if (resp.valid) {
        setUpdateList(false);
        setUpdateList(true);
      }
    });

  return (
    <>
      {selectedItem.possuiSegurosGarantias ? (
        <Collapse bordered={false} defaultActiveKey={['novoItem']} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel
            key="novoItem"
            header={'Cadastro de Seguro ou Garantia' || <FormatText id="ui.commons.filter" camelcase />}
            style={{ border: 0 }}>
            <MasterDetailForm
              onSubmit={submitCreateSeguroGarantia}
              initialValues={dataValue}
              validationSchema={Yup.object().shape({
                nome: Yup.string()
                  .required('Nome deve ser informado')
                  .max(200, 'Nome deve ter no máximo 200 caracteres'),
                numero: Yup.string()
                  .required('Número deve ser informado')
                  .max(200, 'Número deve ter no máximo 200 caracteres'),
                descricao: Yup.string().max(2000, 'Descrição deve ter no máximo 2000 caracteres'),
                tipoDocumentoSeguroGarantiaId: Yup.string().required('Tipo do Documento deve ser informado'),
                vigenciaInicio: Yup.date().required('Data Vigência - Início deve ser informada'),
                vigenciaFim: Yup.date().required('Data Vigência - Fim deve ser informada'),
                // file: Yup.string().required('O arquivo deve ser adicionado'),
              })}>
              <Widget
                className="ant-app-actions-widget"
                actions={[
                  hasPermission(['CONTRATO_SEGURO_GARANTIA_CADASTRAR']) && (
                    <FormSubmitButton noIcon={true} className="btn-primary">
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>
                  ),
                ]}>
                <FormInput label="Nome" name="nome" span={4} />
                <FormInput label="Número" name="numero" span={4} />
                <FormSelect
                  label="Tipo de Documento"
                  placeholder="Selecione uma opção"
                  required
                  getOptions={getTipoDocumentoSeguroGarantiaOptions}
                  name="tipoDocumentoSeguroGarantiaId"
                  span={4}
                />
                <FormDatePicker format="DD/MM/YYYY" label="Data Vigência - Início" name="vigenciaInicio" span={6} />
                <FormDatePicker format="DD/MM/YYYY" label="Data Vigência - Fim" name="vigenciaFim" span={6} />
                <FormTextArea label="Descrição" name="descricao" span={12} rows={4} />
                <FormItem label="Anexo" name="file" span={12}>
                  <UploadFile hasFile={file} idDoComponente={'file'} nameFormData={'file'}/>
                </FormItem>
              </Widget>
            </MasterDetailForm>
          </Panel>
        </Collapse>
      ) : (
        <></>
      )}
      <Widget title="Documentos de Seguros e Garantias">
        {hasPermission(['CONTRATO_SEGURO_GARANTIA_EDITAR']) ? (
          <PerfectScrollbar>
            <InlineEditTable
              className="removeScrollbar"
              columns={columns()}
              dataSource={segurosGarantias}
              updateItem={handleUpdate}
              pagination={false}
            />
          </PerfectScrollbar>
        ) : (
          <PerfectScrollbar>
            <Table columns={columns()} dataSource={segurosGarantias} pagination={false} />
          </PerfectScrollbar>
        )}
      </Widget>
    </>
  );
};

export default AbaSegurosGarantias;
